import { createApp, createSSRApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import './styles/main.css'
import './styles/investigation.css'
import './styles/editorial.css'
import './styles/network.css'
import './styles/jair.css'

const mount = document.querySelector('#app')
const app = mount?.hasAttribute('data-ssg') ? createSSRApp(App) : createApp(App)
app.use(router)
router.isReady().then(() => app.mount('#app'))
